"use client";

import { useGtmProductListingTracking } from "@/hooks/use-gtm-product-listing-tracking";
import type { ProductCardD2CClientProps } from "@/scott/ui/blocks/product-card-d2c/product-card-d2c.client";
import { ProductListingD2C } from "@/scott/ui/blocks/product-listing-d2c/product-listing-d2c";

const LIST_NAME = "Matching Equipment";
const LIST_ID = "matching_equipment";

export interface ProductRelatedProductsSectionProps {
  products: ProductCardD2CClientProps[];
  microcopies: {
    title: string;
    previousSlide: string;
    nextSlide: string;
  };
}

export function ProductRelatedProductsSection(
  props: Readonly<ProductRelatedProductsSectionProps>
) {
  const trackedProducts = useGtmProductListingTracking({
    products: props.products,
    listName: LIST_NAME,
    listId: LIST_ID,
  });

  if (props.products.length === 0) {
    return null;
  }

  return (
    <ProductListingD2C
      backgroundColor="whitesmoke"
      count={props.products.length}
      fullWidth
      microcopies={{
        applyFilters: "",
        clearAllFilters: "",
        closeFilters: "",
        closeSort: "",
        emptyState: "",
        filterProducts: "",
        filterTitle: "",
        loadMore: "",
        loadingProducts: "",
        nextSlide: props.microcopies.nextSlide,
        noFilterOptionsAvailable: "",
        previousSlide: props.microcopies.previousSlide,
        rangeMaximum: "",
        rangeMinimum: "",
        removeFilter: "",
        retry: "",
        sortProducts: "",
        sortTitle: "",
        unableToLoadProducts: "",
      }}
      paddingBottom="large"
      paddingTop="medium"
      products={trackedProducts}
      showCarouselNavigationArrows={false}
      title={props.microcopies.title}
      titleHeadingLevel="h3"
      variant="carousel"
    />
  );
}
